<div
  class="add-section-container"
  [class.dark]="darkBackgroundColor"
  [style.pointer-events]="visible ? 'auto' : 'none'"
>
  @if (visible) {
    <button
      [@button]
      appButton
      name="add-section"
      location="add-section"
      class="add-section"
      color="default-opacity"
      [iconButton]="true"
      shape="round"
      height="0"
      size="1"
      (click)="open()"
      [attr.data-test-id]="testId"
      [center]="true"
      [style.background-color]="backgroundColor || 'white'"
      appTooltip="Add a Section"
    >
      <app-svg src="/assets/icons/16/section-middle.svg" size="-1" [@buttonIcon]></app-svg>
    </button>
  }
</div>
